const WhitePaperContent = {
  init() {
    document.querySelectorAll('.white-paper-content').forEach(section => this.initSection(section));
  },

  initSection(section) {
    const PER_PAGE = 12;
    const tbody = section.querySelector('.white-paper-content__tbody');
    const searchInput = section.querySelector('.white-paper-content__search input');
    const loadMoreWrap = section.querySelector('.white-paper-content__load-more-wrap');
    const loadMoreBtn = section.querySelector('.white-paper-content__load-more');
    const noResults = section.querySelector('.white-paper-content__no-results');

    if (!tbody) return;

    const allRows = [...tbody.querySelectorAll('.wpc-row')];
    let ticking = false;
    const headerMain = document.querySelector('.header-main');

    const updateStickyOffset = () => {
      if (ticking) return;

      ticking = true;
      window.requestAnimationFrame(() => {
        if (window.innerWidth < 768) {
          section.style.removeProperty('--white-paper-sticky-offset');
        } else {
          const offset = headerMain ? Math.round(headerMain.getBoundingClientRect().bottom) : 0;
          section.style.setProperty('--white-paper-sticky-offset', `${offset}px`);
        }
        ticking = false;
      });
    };

    // Sort rows newest to oldest (YYYY-MM-DD string comparison)
    allRows.sort((a, b) => (b.dataset.dateRaw || '').localeCompare(a.dataset.dateRaw || ''));
    const fragment = document.createDocumentFragment();
    allRows.forEach(row => fragment.appendChild(row));
    tbody.appendChild(fragment);

    let shownCount = 0;
    let isSearching = false;

    const showRows = (from, to) => {
      for (let i = from; i < to && i < allRows.length; i++) {
        allRows[i].classList.remove('wpc-row--hidden');
      }
    };

    const hideRows = from => {
      for (let i = from; i < allRows.length; i++) {
        allRows[i].classList.add('wpc-row--hidden');
      }
    };

    const updateLoadMore = () => {
      if (!loadMoreWrap) return;
      loadMoreWrap.style.display = (!isSearching && shownCount < allRows.length) ? 'flex' : 'none';
    };

    const initRows = () => {
      shownCount = Math.min(PER_PAGE, allRows.length);
      showRows(0, shownCount);
      hideRows(shownCount);
      updateLoadMore();
    };

    if (loadMoreBtn) {
      loadMoreBtn.addEventListener('click', () => {
        const newCount = Math.min(shownCount + PER_PAGE, allRows.length);
        showRows(shownCount, newCount);
        shownCount = newCount;
        updateLoadMore();
      });
    }

    if (searchInput) {
      searchInput.addEventListener('input', ({ target }) => {
        const query = target.value.trim().toLowerCase();

        if (!query) {
          isSearching = false;
          allRows.forEach(row => row.classList.remove('wpc-row--hidden'));
          hideRows(shownCount);
          if (noResults) noResults.classList.remove('is-visible');
          updateLoadMore();
          return;
        }

        isSearching = true;
        let matchCount = 0;

        allRows.forEach(row => {
          const { date = '', dateRaw = '', title = '' } = row.dataset;
          const matches = [date, dateRaw, title].some(val => val.includes(query));
          row.classList.toggle('wpc-row--hidden', !matches);
          if (matches) matchCount++;
        });

        if (noResults) noResults.classList.toggle('is-visible', matchCount === 0);
        updateLoadMore();
      });
    }

    initRows();
    tbody.classList.remove('white-paper-content__tbody--loading');
    updateStickyOffset();
    window.addEventListener('load', updateStickyOffset);
    window.addEventListener('resize', updateStickyOffset);

    if (headerMain && 'ResizeObserver' in window) {
      const observer = new ResizeObserver(updateStickyOffset);
      observer.observe(headerMain);
    }
  }
};

export default WhitePaperContent;
